(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  let revealObserver;
  let parallaxItems = [];
  let ticking = false;

  const reveal = (root = document) => {
    const items = root.querySelectorAll('[data-dt-reveal]:not([data-dt-ready])');

    items.forEach((item) => {
      item.setAttribute('data-dt-ready', 'true');
      if (reducedMotion.matches || !('IntersectionObserver' in window)) {
        item.classList.add('is-visible');
        return;
      }
      revealObserver.observe(item);
    });
  };

  const updateParallax = () => {
    if (reducedMotion.matches || window.innerWidth < 768) {
      parallaxItems.forEach((item) => item.style.setProperty('--dt-parallax-y', '0px'));
      ticking = false;
      return;
    }

    const viewportHeight = window.innerHeight;
    parallaxItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      if (rect.bottom < 0 || rect.top > viewportHeight) return;
      const speed = Number(item.dataset.dtParallax || 0.1);
      const centerOffset = rect.top + rect.height / 2 - viewportHeight / 2;
      const offset = Math.max(-90, Math.min(90, centerOffset * speed * -1));
      item.style.setProperty('--dt-parallax-y', `${offset.toFixed(2)}px`);
    });
    ticking = false;
  };

  const requestParallax = () => {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(updateParallax);
  };

  const refresh = (root = document) => {
    reveal(root);
    parallaxItems = Array.from(document.querySelectorAll('[data-dt-parallax]'));
    requestParallax();
  };

  const updateHeader = () => {
    document.body.classList.toggle('dt-scrolled', window.scrollY > 48);
  };

  if ('IntersectionObserver' in window) {
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
  }

  document.addEventListener('DOMContentLoaded', () => {
    refresh();
    updateHeader();
  });

  document.addEventListener('shopify:section:load', (event) => refresh(event.target));
  window.addEventListener('scroll', () => {
    requestParallax();
    updateHeader();
  }, { passive: true });
  window.addEventListener('resize', requestParallax, { passive: true });
  reducedMotion.addEventListener('change', requestParallax);
})();
